import type { ReactNode } from "react";

type SectionProps = {
  id?: string;
  children: ReactNode;
  className?: string;
  /** Wider reading column for lore-style blocks */
  narrow?: boolean;
};

export function Section({
  id,
  children,
  className = "",
  narrow = false,
}: SectionProps) {
  const max = narrow ? "max-w-2xl" : "max-w-3xl lg:max-w-4xl";
  return (
    <section
      id={id}
      className={`relative z-10 px-4 py-16 sm:px-6 sm:py-20 lg:px-8 ${className}`.trim()}
    >
      <div className={`mx-auto ${max}`}>{children}</div>
    </section>
  );
}
